import { Patient, PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { useFormController } from '@dreryk/react-common';
import { StyledFlex, StyledMargin, StyledMaxWidth } from '@dreryk/react-components';

import { getPatientDisplayedFullName } from '../../../common/common.utils';
import { PatientFormLoader } from '../../../common/PatientForm.loader';
import { patientTranslationKeys } from '../../../translations';

import { ExistingPatientAutosuggest } from './ExistingPatientAutosuggest';
import { ExistingPatientFormComparedPatientTextView } from './ExistingPatientFormComparedPatientTextView';

type ExistingPatientFormBean = {
   existingPatient: PatientSimple | null;
};

type ExistingPatientFormChildrenRenderProps = {
   patient: Patient | undefined;
};

type ExistingPatientFormProps = {
   readonly comparedPatient: Omit<PatientSimple, 'medicalDocumentationCreated'>;
   readonly children: (renderProps: ExistingPatientFormChildrenRenderProps) => JSX.Element;
};

export const ExistingPatientForm = (props: ExistingPatientFormProps): JSX.Element => {
   const { register, watch } = useFormController<ExistingPatientFormBean>({
      existingPatient: null,
   });

   const existingPatient = watch('existingPatient');
   const { firstName, lastName } = props.comparedPatient;
   return (
      <>
         <StyledMaxWidth maxWidth={'752px'}>
            <StyledFlex direction={'column'} gap={'18px'}>
               <StyledFlex>
                  <ExistingPatientFormComparedPatientTextView
                     testId={'fullName'}
                     value={getPatientDisplayedFullName(firstName, lastName)}
                     label={patientTranslationKeys.unconfirmed.fullName}
                  />
                  <ExistingPatientFormComparedPatientTextView
                     testId={'phoneNumber'}
                     value={props.comparedPatient.phoneNumber?.asString()}
                     label={patientTranslationKeys.unconfirmed.phoneNumber}
                  />
               </StyledFlex>
               <ExistingPatientAutosuggest register={register} comparedPatientId={props.comparedPatient.id} />
            </StyledFlex>
         </StyledMaxWidth>
         {existingPatient ? (
            <StyledMargin top={18}>
               <PatientFormLoader patientId={existingPatient.id.toString()}>{props.children}</PatientFormLoader>
            </StyledMargin>
         ) : (
            props.children({ patient: undefined })
         )}
      </>
   );
};
